import React from 'react';
import "../Assets/Styles/Style.css";
import config from ".././config/Global.json"
const Footer = () => {
  const { api: { version } } = config;
  return (
    <footer className="footer app-footer">
      <div className="container">
      <p>Developed by Humbingo Consultancy Services</p>
      <p> Version: {version}</p>
      </div>
    </footer>
  );
}

export default Footer;
